export default {
    title: "Lar",
    button: {
        accessories: "Navegar no Catálogo"
    },
    noAvailableItems: "Não há produtos disponíveis para encomenda.",
    error: "Ocorreu um problema ao recuperar produtos. Atualize seu navegador."
}